import React from 'react';
import { createPortal } from 'react-dom';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import constants from '../constants.json' assert { type: 'json' };

const AbtraPlayerVideoPortal = ({ videoUrl, thumbnailImageLink, container }) => {
    return createPortal(
        <div
            className={constants.ABTRA_EDITOR.ABTRA_PLAYER_VIDEO_CLASS_NAME}
            style={{
                width: constants.ABTRA_EDITOR.ABTRA_VIDEO_WIDTH,
                height: constants.ABTRA_EDITOR.ABTRA_VIDEO_MIN_HEIGHT,
            }}
        >
            <ReactPlayer
                url={videoUrl}
                width={'100%'}
                height={'100%'}
                controls={true}
                playing={true}
                light={thumbnailImageLink || true}
            />
        </div>,
        container
    );
};

AbtraPlayerVideoPortal.PropTypes = {
    videoUrl: PropTypes.string,
    thumbnailImageLink: PropTypes.string,
    container: PropTypes.object,
};

export default AbtraPlayerVideoPortal;
